import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=ae60ba64&"
import script from "./LandingLayout.vue?vue&type=script&lang=js&"
export * from "./LandingLayout.vue?vue&type=script&lang=js&"
import style0 from "./LandingLayout.vue?vue&type=style&index=0&id=ae60ba64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports